module.exports = __webpack_public_path__ + "img/working-info.aff36d86.svg";